module.exports = __webpack_public_path__ + "img/youshi.485db22a.png";